import constant from '../../store/constant'
import AppHeader from '../AppHeader'

export default {
  name: 'introduction-detail',
  created () {
    this.search()
  },
  data () {
    return {
      referral: "",
      introduction: "",
      callbackflg: false
    }
  },
  computed: {
    nowJob () {
      if (this.introduction['friend-now-job-other']) {
        return this.introduction['friend-now-job'] + ' ' + '(' + this.introduction['friend-now-job-other'] + ')'
      } else {
        return this.introduction['friend-now-job']
      }
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goBackList: function () {
      this.$router.push({ path: '/introduction/'})
    },
    search: function () {
      let data = {
        introduction_id: this.$route.params.introduction_id
      }
      this.$store
        .dispatch('GET_INTRODUCTION_DETAIL', { data: data })
        .then(res => {
          this.introduction = res.introduction.data.attributes
          this.referral = res.referral.data.attributes
          this.callbackflg = true
        })
        .catch(err => console.log(err))
    },
    completed: function () {
      if (window.confirm('店舗伝達済みにします。')) {
        let data = {
          user_id: localStorage.user_id,
          introduction_id: this.$route.params.introduction_id
        }
        this.$store
          .dispatch('PATCH_INTRODUCTION_COMPLETE', { data: data })
          .then(res => {
            this.search()
          })
          .catch(err => console.log(err))
      }
    },
    printIntroduction: function () {
      let data = {
        introduction_id: this.$route.params.introduction_id
      }
      this.$store
      .dispatch('PRINT_INTRODUCTION', { data: data })
      .then(res => {
        // let bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        let blob = new Blob([res], { 'type': 'application/pdf' })
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, 'introduction.pdf')
        } else {
          let objectURL = URL.createObjectURL(blob)
          window.open(objectURL)
        }
      })
      .catch(err => console.log(err))
    },
    telChange: function (tel) {
      return 'tel:' + tel
    },
    wordReplace: function (word) {
      return word ? word.replace(/\r?\n/g, '<br>') : ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/introduction-detail.js